import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { api, mapRows } from "./api";

/**
 * Fetches faculty_profile_fields to find the 'category' field key.
 * Returns a filter function: user => boolean
 */
export async function fetchDoctorFilter() {
  try {
    const res = await api.get("/faculty_profile_fields?orderBy=order");
    const fields = mapRows(res);

    const catField = fields.find((f) => {
      const nm = (f.name || "").toLowerCase().trim();
      return nm.includes("category");
    });

    if (catField) {
      const catKey = catField.key || catField.name.toLowerCase().replace(/[^a-z0-9]/g, "_");
      return (u) => {
        if (!u.empId?.trim()) return false;

        const email = (u.email || "").toLowerCase();
        const dept = (u.department || "").toLowerCase();
        if (email.includes("hr@") || email.includes("it@") || dept.includes("it dept") || dept.includes("hr ")) return false;

        const cat = (u[catKey] || "").toLowerCase().trim();
        return cat === "doctor" || cat === "doctors";
      };
    }
  } catch (e) {
    console.error("fetchDoctorFilter error:", e);
  }

  return (u) => {
    if (!u.empId?.trim()) return false;

    const email = (u.email || "").toLowerCase();
    const dept = (u.department || "").toLowerCase();
    const desig = (u.designation || "").toLowerCase();
    const name = (u.name || "").toLowerCase();

    if (
      email.includes("hr@") || email.includes("it@") ||
      dept.includes("it dept") || dept.includes("hr ") ||
      name.includes("it dept") || name.includes("hr manager") ||
      desig.includes("hr ") || desig === "hr manager"
    ) {
      return false;
    }

    return true;
  };
}

export const downloadPDF = async (printRef, filename = "report.pdf", options = {}) => {
  if (!printRef.current) return;

  try {
    const element = printRef.current;

    const canvas = await html2canvas(element, {
      scale: options.scale || 2,
      useCORS: true,
      logging: false,
      backgroundColor: "#ffffff",
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: options.orientation || "p",
      unit: "mm",
      format: "a4",
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgProps = pdf.getImageProperties(imgData);
    const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
    heightLeft -= pdfHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save(filename);
    return true;
  } catch (error) {
    console.error("PDF Generation failed:", error);
    return false;
  }
};

export const formatDuration = (durationStr) => {
  if (!durationStr || typeof durationStr !== "string") return durationStr || "—";

  if (durationStr.includes("Year") || durationStr.includes("Month") || durationStr.includes("Day")) return durationStr;

  const result = durationStr
    .replace(/(\d+)Y/g, (match, p1) => `${p1} Year${parseInt(p1) === 1 ? "" : "s"} `)
    .replace(/(\d+)M/g, (match, p1) => `${p1} Month${parseInt(p1) === 1 ? "" : "s"} `)
    .replace(/(\d+)D/g, (match, p1) => `${p1} Day${parseInt(p1) === 1 ? "" : "s"} `)
    .trim();

  return result || durationStr;
};
